import { render, staticRenderFns } from "./FooterYjj.vue?vue&type=template&id=4f28d6af&scoped=true&"
import script from "./FooterYjj.vue?vue&type=script&lang=js&"
export * from "./FooterYjj.vue?vue&type=script&lang=js&"
import style0 from "./FooterYjj.vue?vue&type=style&index=0&id=4f28d6af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f28d6af",
  null
  
)

export default component.exports